<template>
  <ValidationProvider
    :name="name"
    :rules="rules"
    v-slot="{ errors }"
    :custom-messages="customMessages"
  >
    <AGCLabel v-if="label" :required="required" :id="id">
      <slot>{{ label }}</slot>
      <template v-slot:subLabel>
        <slot name="subLabel">{{ subLabel }}</slot>
      </template>
    </AGCLabel>
    <b-form-group>
      <b-form-checkbox-group
        :id="id"
        v-model="inputVal"
        :state="state(errors)"
        :options="processedOptions"
        :value-field="valueField"
        :text-field="textField"
        :disabled-field="disableField"
        :disabled="disabled"
      ></b-form-checkbox-group>
      <b-form-invalid-feedback :state="state(errors)">
        {{ errors[0] }}
      </b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>

<script>
import { BFormGroup, BFormCheckboxGroup, BFormInvalidFeedback } from 'bootstrap-vue';
import agcFormElementMixin from '../../mixins/agc-form-element';

export default {
  components: {
    BFormGroup,
    BFormCheckboxGroup,
    BFormInvalidFeedback,
  },
  mixins: [agcFormElementMixin],
  props: {
    options: Array,
    valueField: { type: String, default: 'item' },
    textField: { type: String, default: 'name' },
    disableField: { type: String, default: 'disabled' },
  },
  computed: {
    processedOptions() {
      if (this.inputVal?.length === this.max) {
        // disallow other options except those are checked
        return this.options.map(({ id, name }) => {
          // allow to uncheck
          if (this.inputVal.some((val) => parseInt(val, 10) === parseInt(id, 10))) {
            return { id, name };
          }
          return { id, name, disabled: true };
        });
      }
      return this.options;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .custom-checkbox {
    padding-left: 0;
    margin: 0 12px 12px 0;

    @include respond(phone) {
      margin: 0 12px 8px 0;
    }

    label {
      &::before,
      &::after {
        opacity: 0;
      }
    }
    input[type="checkbox"] {
      & + label {
        color: #636d77;
        font-size: 15px;
        border-radius: 23px;
        padding: 12px 20px;
        cursor: pointer;
        background: #f0f4f6;
        border: 1px solid #ffffff;
        white-space: nowrap;

        @include respond(phone) {
          font-size: 12px;
        }
      }

      &:checked + label {
        background: #e0effd;
        border: 1px solid #b1d7fb;
        color: #318ce1 !important;
      }
    }
  }
}
</style>
